angular.module('kareo.ui.shared.directives.profile-image', [])
  .directive('profileImage', [
    function () {
      return {
        template: require('./profile-image.pug')(), restrict: 'E', scope: {
          person: '=' // must have 'photo' and 'type'
        }, controller: [
          '$scope', function ($scope) {
            var person = $scope.person;
            $scope.photo = (person && person.photo) ? person.photo : '/common-ui/image/icons/generic-person.svg';
            $scope.image_format = 'svg';
          }]
      };
    }]);
